import React, { useState } from "react";
import "./exammenu.css";
import { NavLink } from "react-router-dom";
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import Modal from 'react-bootstrap/Modal';
import { FaAngleRight } from "react-icons/fa";
import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import axios from "axios";
import { BiSearch } from "react-icons/bi";
import { Form } from "react-bootstrap";

import Suggestion from "../popup/Suggestion";
import { toast } from "react-toastify";
import { baseUrl } from "../../context/BaseUrl";

const Exammenu = (props) => {
  const [Data, setData] = useState(null);
  const [result, setResult] = useState(false);

  const [search, setSearch] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const handleSuggestions = () => setShowSuggestions(!showSuggestions);

  async function fetchData() {
    try {
      const response = await axios.get(
        `${baseUrl}/user/category/getcategory_details`
      );
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    //fetch request js?

    if (search.length > 0) {
      setResult(false);
    }

    if (search && search.length > 0) {
      (async () => {
        try {
          const rawResponse = await fetch(
            `${baseUrl}/user/search/${search}`,
            {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          const content = await rawResponse.json();
          console.log(content);
          setResult(() => content);
        } catch (error) {
          setResult(false);
        }
      })();
    } else {
      setResult(false);
    }
  }, [search]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    Data !== null && (
      <>
        <div className="menudropdown1" style={{ lineHeight: "40px" }}>
          {/* <ul className={`${props.home == 'homepage' ? 'd-none' : "d-flex"}`}>
          <li className="">
              <span
          
                className=" cursor-pointer nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block"
              >
                Exams
              </span>

              <ul>
                {Data.map((item) => (
                  <li>
                    {item.category_name} <FaAngleRight />
                    <ul>
                      <li>Civil Services 1</li>
                      <li>Civil Services 2</li>
                      <li>Civil Services 3</li>
                    </ul>
                  </li>
                ))}
                </ul>
            </li>
            <li>
              <NavLink
                to="/upsc"
                variant="primary"
                className="nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block register"
              >
                Upsc
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to=""
                variant="primary"
                className="nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block register"
              >
                Suggestions
              </NavLink>
            </li>
          </ul> */}
          <ul className="d-flex">
            <li className="">
              <span className=" cursor-pointer nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block">
                Exams
              </span>

              <ul className="submenu">
                {Data.map((item, index) => (
                  <li key={index}>
                    <NavLink
                      to={`/exams/${item.category_name.replace(" ","-")}/${item._id}`}
                      variant="primary"
                      className="nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block register"
                    >
                      {item.category_name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
            <li className="w-100">
              <NavLink
                to=""
                onClick={handleShow}
                variant="primary"
                className="nav-link-lg me-5 starte text-decoration-none d-none d-lg-inline-block register"
              >
                Suggestions
              </NavLink>

              <Suggestion handle={{ show, setShow }} />
            </li>
            <li className="w-100">
              <NavLink
                to="/vacancy"
                onClick={handleShow}
                className="nav-link-lg me-5  text-decoration-none d-none d-lg-inline-block register"
              >
                Vacancy
              </NavLink>
            </li>
          </ul>
        </div>

        {/* suggestion modal popup start */}
        {/* <Modal show={show} onHide={handleClose} className='suggestion-box'>
                <Modal.Header closeButton>
                    <Modal.Title>Suggestion Box</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-4" controlId="FormInput">
                            <Form.Control
                                type="text"
                                placeholder="Name"
                                autoFocus
                                onChange={(e) => setName(e.target.value)} value={Name}
                            />
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="FormInput">
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                autoFocus
                                onChange={(e) => setEmail(e.target.value)} value={Email}
                            />
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="FormInput">
                            <Form.Control
                                type="text"
                                placeholder="Phone Number"
                                autoFocus
                                onChange={(e) => setNumber(e.target.value)} value={Number}
                            />
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="FormTextarea">
                            <Form.Control as="textarea" rows={4}
                                placeholder="Type Message"
                                onChange={(e) => setMessage(e.target.value)} value={Message}
                            />
                        </Form.Group>
                    </Form>

                    <Button variant="primary" onClick={handleSent}>
                        Send Suggestion
                    </Button>
                </Modal.Body>
            </Modal> */}
      </>
    )
  );
};

export default Exammenu;
